var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-label"},[_vm._t("default"),(_vm.type === 'required')?_c('div',{staticClass:"-required"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }